/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { BaseResponse } from '../models/base-response';
import { UserResponse } from '../models/user-response';
import { userRoleControllerCreate } from '../fn/user-role/user-role-controller-create';
import { UserRoleControllerCreate$Params } from '../fn/user-role/user-role-controller-create';
import { userRoleControllerDelete } from '../fn/user-role/user-role-controller-delete';
import { UserRoleControllerDelete$Params } from '../fn/user-role/user-role-controller-delete';
import { userRoleControllerGetAll } from '../fn/user-role/user-role-controller-get-all';
import { UserRoleControllerGetAll$Params } from '../fn/user-role/user-role-controller-get-all';
import { userRoleControllerGetOne } from '../fn/user-role/user-role-controller-get-one';
import { UserRoleControllerGetOne$Params } from '../fn/user-role/user-role-controller-get-one';
import { userRoleControllerGetUsers } from '../fn/user-role/user-role-controller-get-users';
import { UserRoleControllerGetUsers$Params } from '../fn/user-role/user-role-controller-get-users';
import { userRoleControllerUpdate } from '../fn/user-role/user-role-controller-update';
import { UserRoleControllerUpdate$Params } from '../fn/user-role/user-role-controller-update';
import { UserRoleItem } from '../models/user-role-item';
import { UserRoleResponse } from '../models/user-role-response';

@Injectable({ providedIn: 'root' })
export class UserRoleService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `userRoleControllerGetAll()` */
  static readonly UserRoleControllerGetAllPath = '/user-role';

  /**
   * Restituisce l'elenco dei ruoli.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userRoleControllerGetAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  userRoleControllerGetAll$Response(params: UserRoleControllerGetAll$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: UserRoleResponse;
}>> {
    return userRoleControllerGetAll(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce l'elenco dei ruoli.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userRoleControllerGetAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userRoleControllerGetAll(params: UserRoleControllerGetAll$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: UserRoleResponse;
}> {
    return this.userRoleControllerGetAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: UserRoleResponse;
}>): BaseResponse & {
'data'?: UserRoleResponse;
} => r.body)
    );
  }

  /** Path part for operation `userRoleControllerCreate()` */
  static readonly UserRoleControllerCreatePath = '/user-role';

  /**
   * Crea un ruolo con o senza grant associati.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userRoleControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userRoleControllerCreate$Response(params: UserRoleControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: UserRoleItem;
}>> {
    return userRoleControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Crea un ruolo con o senza grant associati.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userRoleControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userRoleControllerCreate(params: UserRoleControllerCreate$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: UserRoleItem;
}> {
    return this.userRoleControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: UserRoleItem;
}>): BaseResponse & {
'data'?: UserRoleItem;
} => r.body)
    );
  }

  /** Path part for operation `userRoleControllerGetOne()` */
  static readonly UserRoleControllerGetOnePath = '/user-role/{id}';

  /**
   * Restituisce un ruolo.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userRoleControllerGetOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  userRoleControllerGetOne$Response(params: UserRoleControllerGetOne$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: UserRoleItem;
}>> {
    return userRoleControllerGetOne(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce un ruolo.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userRoleControllerGetOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userRoleControllerGetOne(params: UserRoleControllerGetOne$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: UserRoleItem;
}> {
    return this.userRoleControllerGetOne$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: UserRoleItem;
}>): BaseResponse & {
'data'?: UserRoleItem;
} => r.body)
    );
  }

  /** Path part for operation `userRoleControllerDelete()` */
  static readonly UserRoleControllerDeletePath = '/user-role/{id}';

  /**
   * Elimina un ruolo.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userRoleControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  userRoleControllerDelete$Response(params: UserRoleControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: UserRoleItem;
}>> {
    return userRoleControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Elimina un ruolo.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userRoleControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userRoleControllerDelete(params: UserRoleControllerDelete$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: UserRoleItem;
}> {
    return this.userRoleControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: UserRoleItem;
}>): BaseResponse & {
'data'?: UserRoleItem;
} => r.body)
    );
  }

  /** Path part for operation `userRoleControllerUpdate()` */
  static readonly UserRoleControllerUpdatePath = '/user-role/{id}';

  /**
   * Modifica un ruolo.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userRoleControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userRoleControllerUpdate$Response(params: UserRoleControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: UserRoleItem;
}>> {
    return userRoleControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Modifica un ruolo.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userRoleControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userRoleControllerUpdate(params: UserRoleControllerUpdate$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: UserRoleItem;
}> {
    return this.userRoleControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: UserRoleItem;
}>): BaseResponse & {
'data'?: UserRoleItem;
} => r.body)
    );
  }

  /** Path part for operation `userRoleControllerGetUsers()` */
  static readonly UserRoleControllerGetUsersPath = '/user-role/{id}/users';

  /**
   * Restituisce gli utenti di un ruolo.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userRoleControllerGetUsers()` instead.
   *
   * This method doesn't expect any request body.
   */
  userRoleControllerGetUsers$Response(params: UserRoleControllerGetUsers$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: UserResponse;
}>> {
    return userRoleControllerGetUsers(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce gli utenti di un ruolo.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userRoleControllerGetUsers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userRoleControllerGetUsers(params: UserRoleControllerGetUsers$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: UserResponse;
}> {
    return this.userRoleControllerGetUsers$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: UserResponse;
}>): BaseResponse & {
'data'?: UserResponse;
} => r.body)
    );
  }

}
